import type { TakenActionsByIssue } from "./TakenActions.types"

// A module store, not a context: the triage table and the drawer are siblings,
// so a provider would have to sit in LayoutTemplate. Kept in memory on purpose
// so a page refresh resets the demo.
const listeners = new Set<() => void>()

let snapshot: TakenActionsByIssue = {}

export const getTakenActions = (): TakenActionsByIssue => snapshot

export const subscribeTakenActions = (listener: () => void) => {
  listeners.add(listener)

  return () => {
    listeners.delete(listener)
  }
}

export const setTakenActions = (
  update: (previous: TakenActionsByIssue) => TakenActionsByIssue
) => {
  const next = update(snapshot)

  if (next === snapshot) return

  snapshot = next
  listeners.forEach((listener) => listener())
}
